import { getDatabase, ref as dbRef, set, get, onValue } from 'firebase/database';

// Konfiguration speichern
export async function saveTaskConfig(customerId, config) {
    const db = getDatabase();
    const configRef = dbRef(db, `customers/${customerId}/taskConfig`);
    await set(configRef, config);
}

// Konfiguration laden
export async function loadTaskConfig(customerId) {
    const db = getDatabase();
    const configRef = dbRef(db, `customers/${customerId}/taskConfig`);
    const snapshot = await get(configRef);
    return snapshot.exists() ? snapshot.val() : null;
}

// Echtzeit-Listener für Konfigurationsänderungen
export function onTaskConfigChange(customerId, callback) {
    const db = getDatabase();
    const configRef = dbRef(db, `customers/${customerId}/taskConfig`);
    onValue(configRef, (snapshot) => {
        const config = snapshot.val();
        callback(config);
    });
}
